import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/lib/theme-chalk/index.css'
import 'normalize.css'
// import '../theme/index.css';  // TODO: 主题调整
import App from './App.vue'
import './iconfont/iconfont.css'
import { checkLogin } from './utils/index'
import { initKeepAliveCfg } from './utils/keepAliveCfg'
import { I18n, I18nMixins } from '@/utils/i18n'
import router from './router'
import store from './store'
import { setupFeUtils } from './utils/setupFeUtils'
import captcha from 'mcaptcha/dist/assets/js/captcha.min.js'
import 'mcaptcha/dist/assets/css/captcha.min.css'
import { directives } from '@/directives/index'
import { setupBigDataLog } from './bigData/setupBigDataLog'
import { setupMessageCenter } from './message/setupMessageCenter'
import scroll from 'vue-seamless-scroll/src'
import { clearDictCache } from './utils/dictCacheUtils'
// 图片预览
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import { setupMonitor } from './monitor/setup'
import { setupDataFinder } from './utils/datafinder/setup'

setupFeUtils()
setupMessageCenter()

const app = createApp(App)

setupMonitor(app)

setupBigDataLog(app, store, router)

setupDataFinder()

;(async function () {
    const isLogin = await checkLogin()
    if (isLogin) {
        initKeepAliveCfg()
    }
    store.dispatch('UPDATE_LANG', app).then(res => {
        clearDictCache()
        app.use(ElementPlus, {
            size: 'mini',
        })
            .use(directives)
            .use(store)
            .use(router)
            .mixin(I18nMixins)
            .use(I18n())
            .use(VueViewer)
            .use(scroll)
            .mount('#app')
    })
})()

app.config.globalProperties.$captcha = captcha

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
        registration.unregister()
    })
}
